import React, { useEffect } from 'react';
import Chart from 'react-apexcharts';
import styled from 'styled-components';
import { Flex } from 'antd';

import { ChartWrapper } from '../../../components/Charts/ChartWrapper';
import { useAppSelector } from '../../../../../store';
import { useLazyGetFinanceQuery } from '../service/finance.api';
import { currencyFormat, getChartOptions } from '../utils/chartOptions';
import { ListBadge } from '../../ChatList/components/ListBadge';
import { selectAnalyticsFilters } from '../../../store/analyticFiltersSlice';

export const FinanceChart = () => {
    const filters = useAppSelector(selectAnalyticsFilters);

    const [
        getFinance,
        {
            data = {
                balance: [],
                course: [],
                donate: [],
                labels: [],
                rate: [],
                all: 0,
            },
            isLoading,
            isFetching,
        },
    ] = useLazyGetFinanceQuery();

    useEffect(() => {
        if (filters) {
            const payload = {
                ...filters,
                community_id: Number(filters.chat) || null,
            };

            getFinance(payload, true);
        }
    }, [filters]);

    const series = [];

    if (data.donate.some(d => d > 0))
        series.push({
            name: 'Донаты',
            data: data.donate,
        });
    if (data.rate.some(d => d > 0))
        series.push({
            name: 'Тариф',
            data: data.rate,
        });
    if (data.course.some(d => d > 0))
        series.push({
            name: 'Медиатовары',
            data: data.course,
        });

    return (
        <ChartWrapper isLoading={isLoading || isFetching} title='Финансы'>
            <Flex justify={'space-between'}>
                <StyledLegendContainer>
                    <div className='counter'>{currencyFormat(data.all)}</div>
                    {data.donate.some(d => d > 0) && (
                        <ListBadge text='Донаты' color='#D6E4FF' />
                    )}
                    {data.rate.some(r => r > 0) && (
                        <ListBadge text='Тариф' color='#ADC6FF' />
                    )}
                    {data.course.some(c => c > 0) && (
                        <ListBadge text='Медиатовары' color='#597EF7' />
                    )}
                </StyledLegendContainer>
                <StyledChart
                    height={'200px'}
                    type='bar'
                    options={getChartOptions(data, filters)}
                    series={series}
                />
            </Flex>
        </ChartWrapper>
    );
};

const StyledChart = styled(Chart)``;
const StyledLegendContainer = styled.div`
    height: 100%;
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .counter {
        color: #2f54eb;
        font-size: 36px;
        font-weight: 300;
    }

    .result {
        color: #139c55;
        font-size: 24px;
        font-weight: 300;
    }

    .description {
        font-size: 12px;
        font-weight: 400;
        color: rgba(37, 33, 41, 0.45);
    }
`;
